export default __webpack_public_path__ + "static/media/SR.3a8304d7.svg";